module.exports = __webpack_public_path__ + "static/WelcomeToElk4-408aee30c27a10559d4660c4277a87d4.webp";